import { getAccess, getRole } from "../helpers/ReduxHelpers";
import UnauthorizedPage from "./UnauthorizedPage";

export default function ProtectedRoute({ role, children }) {

    const accessList = getAccess();

    const checkPassed = accessList.includes(role)
    if (checkPassed) return <>{children}</>
    return <UnauthorizedPage />
}


// check user management's read and write roles
export const MultiRoleProtectedRoute = ({ role, children }) => {
    // Module flags plus JWT roles (e.g. ROLE_PROSHIPADMIN) — for routes gated
    // on a backend isProshipAdmin() check rather than a granted module.
    // Existing role arrays only ever list module flags, so this merge is
    // additive and doesn't change any other route's behavior.
    const accessList = [...getAccess(), ...getRole()];
    const hasAccess = role?.some(role => accessList.includes(role));
    return hasAccess ? <>{children}</> : <UnauthorizedPage />;
};
